<template>
  <v-dialog v-model="intDialogVisible" max-width="600px" class="addValueModal addComment">
    <v-card>
      <v-card-title v-if="candidate">
        <h3 class="primary--text formName" v-if="candidate.name">Comments for {{candidate.name}}</h3>
        <h3 class="primary--text formName" v-else-if="candidate.startup">Comments for {{candidate.startup.name}}</h3>
        <h3 class="primary--text formName" v-else>Comments</h3>


      </v-card-title>
      <v-card-text>

        <div class="candidate_links candidate_comments" style="" v-if="candidate">
          <div class="" v-if="candidate.comments">
          <div class="" v-if="candidate.comments.length > 0">

          <div class="comments_list">
              <div class="one_comment" v-for="(comment, i) in candidate.comments" :key="i">
                <span v-if="comment.value"> <strong v-if="comment.by">{{comment.by}} : </strong><span v-html="comment.value" class="comment_value"></span></span>
                    <span v-else>{{comment}}</span>
              </div>

          </div>
              </div>

          </div>
  </div>
          <div class="" style="margin-top:25px">


        <strong>Add a new comment</strong>
        <v-form class=""  @submit.prevent="submit">
          <v-textarea v-model="customerValue" class="addValueInput" rows="3"></v-textarea>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn @click="close" >
              Close
            </v-btn>
            <v-btn class="addValue" @click="submit" >
              Add
            </v-btn>
          </v-card-actions>
        </v-form>
                  </div>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    dialogVisible: Boolean,
    formName: String,
    candidate :Object
  },
  data () {
    return{
      customerValue:'',
      returnedCustomerValue:'',
    }
  },
  methods:{
    submit(){
      this.returnedCustomerValue = this.customerValue;
      this.customerValue = "";
       this.$emit('newValueIsProposed',this.returnedCustomerValue)
    },
    close(){
        this.$emit('close',false)
    }
  },
  computed: {
    intDialogVisible: {
      get: function () {
        if (this.dialogVisible) {
          // Some dialog initialization code could be placed here
          // because it is called only when this.dialogVisible changes
        }

        return this.dialogVisible
      },
      set: function (value) {
             if (!value) {
                this.$emit('close', value);
             }
      }
    }
  },
  watch: {
    dialogVisible: function(){
      this.customerValue = "";
    }
  }

}
</script>

<style media="screen" scoped>
  .addValueModal .v-card{
    padding:10px;
  }
  .addValueModal .v-field__outline{
    display:none;
  }
  .formName{
    text-align: left;
    font-size: 21px;
    line-height: 25px;
    color: #3783C5;
  }
  .addValueModal button{
    border: 1px solid #3783C5;
    border-radius: 50px;
    opacity: 1;
    padding: 7px 18.5px;
    color:#3783C5;
    margin: 5px;
  }
  .comment_value{
    font-size: 16px;
    line-height: 22px;
  }

    .addValueModal button.addValue{
      border: 1px solid #3783C5;

      background:#3783C5;
      color:#fff;
    }

    .addValueInput input{
      border: 1px solid #DDDDDD;
      border-radius:20px;
    }
  .addComment textarea{
    width: 100%;
margin: 0;
border: 1px solid #DDDDDD;
mask-image: none !important;
border-radius:20px;
  }
  .v-card-title{
    white-space: normal !important;
  }


  .candidate_comments{
    padding: 0;
    margin-top:auto;
  }
  .candidate_comments .one_comment{
    margin-top:10px;
    margin-bottom: 10px;
    font-size:12px;
    line-height:15px;
      position:relative;
  }
  .candidate_comments .one_comment:after {
    content: ""; /* This is necessary for the pseudo element to work. */
       display: block; /* This will put the pseudo element on its own line. */
       margin: 0 ; /* This will center the border. */
       width: 20%; /* Change this to whatever width you want. */
       padding-top: 10px; /* This creates some space between the element and the border. */

       border-bottom: 1px solid #CCC; /* This creates the border. Replace black with whatever color you want. */
  }
  .candidate_comments small{
    font-size:12px;
  }
</style>
